import { getRequest, postRequest } from "api/axiosClient";

import { BaseParamsRequest } from "api/request/basParams.request";
import { GetAnalyticsRequestParams } from "../request";
import {
  GetAnalyticsBillingResponseType,
  GetAnalyticsResponseType,
  GetAnalyticsOnTimePerformanceResponseType,
  GetAnalyticsRatingResponseType,
  GetAnalyticsQuotingPerformanceResponseType,
} from "../response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/analytics`;

const getBillingAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsBillingResponseType>(`${baseURL}/billing`, params);
const getFreightModeAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest(`${baseURL}/list-by-mode`, params);
const getLocationAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsResponseType>(`${baseURL}/list-by-team`, params);
const getOntimePerformanceAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsOnTimePerformanceResponseType>(`${baseURL}/list-by-provider/ontime-performance`, params);
const getProviderAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsResponseType>(`${baseURL}/list-by-provider`, params);
const getProviderRatingAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsRatingResponseType>(`${baseURL}/list-by-provider/provider-ratings`, params);
const getQuotingPerformanceAnalytics = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  getRequest<GetAnalyticsQuotingPerformanceResponseType>(`${baseURL}/list-by-provider/quoting-performance`, params);

const exportProviderListXLSX = (params: BaseParamsRequest<GetAnalyticsRequestParams>) =>
  postRequest(`${baseURL.replace("/analytics", "")}/user/analytics/export-list-by-provider`, params);

export {
  getBillingAnalytics,
  getFreightModeAnalytics,
  getLocationAnalytics,
  getOntimePerformanceAnalytics,
  getProviderAnalytics,
  getQuotingPerformanceAnalytics,
  getProviderRatingAnalytics,
  exportProviderListXLSX,  
};
